// ================================================================
// Platform AI-Usage API — Verbrauchszahlen aller Firmen
// (nur Plattform-Rollen, Recht platform:usage:read)
// ================================================================
import { apiRequest } from './apiClient.js';

export function getAiUsage(days = 30) {
  return apiRequest('/api/platform/ai-usage?days=' + encodeURIComponent(days));
}
